import { SchoolGroup, StrandedPupil } from "@core/models/domain/group.domain";
import { CreateSchoolGroupRequest, ModifySchoolGroupRequest } from "@core/models/request/group.request";
import {createAction, props} from "@ngrx/store";

// LOAD GROUPS
export const loadGroups = createAction('[Group] Load Groups');
// Store-first variant: only triggers loadGroups when the cache is empty, stale or invalidated.
export const loadGroupsIfNeeded = createAction('[Group] Load Groups If Needed');
export const loadGroupsSuccess = createAction(
    '[Group] Load Groups Success',
    props<{ groups: SchoolGroup[] }>()
);
export const loadGroupsFailure = createAction(
    '[Group] Load Groups Failure',
    props<{ error: any }>()
);

// CREATE GROUP
export const createGroup = createAction(
    '[Group] Create Group',
    props<{ request: CreateSchoolGroupRequest }>()
);
export const createGroupSuccess = createAction(
    '[Group] Create Group Success',
    props<{ group: SchoolGroup }>()
);
export const createGroupFailure = createAction(
    '[Group] Create Group Failure',
    props<{ error: any }>()
);

// UPDATE GROUP
export const updateGroup = createAction(
    '[Group] Update Group',
    props<{ request: ModifySchoolGroupRequest }>()
);
export const updateGroupSuccess = createAction(
    '[Group] Update Group Success',
    props<{ group: SchoolGroup }>()
);
export const updateGroupFailure = createAction(
    '[Group] Update Group Failure',
    props<{ error: any }>()
);

// REMOVE GROUP
export const deleteGroup = createAction(
    '[Group] Delete Group',
    props<{ groupId: string; acknowledgeStrandedPupils?: boolean }>()
);
/** The backend refused the removal because it would leave these pupils in no active group. */
export const deleteGroupBlocked = createAction(
    '[Group] Delete Group Blocked',
    props<{ groupId: string; pupils: StrandedPupil[] }>()
);
export const deleteGroupSuccess = createAction(
    '[Group] Delete Group Success',
    props<{ groupId: string }>()
);
export const deleteGroupFailure = createAction(
    '[Group] Delete Group Failure',
    props<{ error: any }>()
);